import createImageUrlBuilder from "@sanity/image-url";
import { createClient } from "next-sanity";
import useTranslation from "next-translate/useTranslation";
import React from "react";
import CommentReusirVotreVenteCards from "SanityComponents/CommentReusirVotreVenteCards";
import OffreProComponent from "../sanity/Components/OffreProComponent/OffreProComponent";
import PackContainerComponent from "../sanity/Components/PackContainerComponent/PackContainerComponent";
import SanityHeadSeo from "../sanity/Components/SanityHeadSeo/SanityHeadSeo";
import TextBanner from "../sanity/Components/TextBanner/TextBanner";
import AideCards from "../SanityComponents/CreditImmobilierComponents/AideCards/AideCard";
import EstimationHeader from "../SanityComponents/CreditImmobilierComponents/EstimationHeader";
import LandingPageHeader from "../SanityComponents/CreditImmobilierComponents/LPHeader";
import Footer from "../SanityComponents/Footer/Footer";
import Question from "../SanityComponents/Question/Question";
import Simulez from "../SanityComponents/Simulez/Simulez";
import SubHeader from "../SanityComponents/SubHeader/SubHeader";
import style from "./style.module.css";
import FAQ from "../SanityComponents/FAQ/FAQ";
import ThreeGuideButtons from "SanityComponents/GuideDuCredit/ThreeGuideButtons";
import ThreeButtons from "SanityComponents/LandingPage/ThreeButtons";
import ProvincesMaroc from "assets/ProvincesMaroc/ProvincesMaroc.json";
import EstimationImmobilierTitleOneTexte from "SanityComponents/EstimationEmmobilier/EstimationImmobilierTitleOneTexte";
import EstimationImmobilierTitleTwoTextes from "SanityComponents/EstimationEmmobilier/EstimationImmobilierTitleTwoTextes";
import EstimationImmobilierThreeButtons from "SanityComponents/EstimationEmmobilier/EstimationImmobilierThreeButtons";
import LpPrixImmobilier from "SanityComponents/LandingPage/LpPrixImmobilier";
import AnnoncesCards from "SanityComponents/Annonces/AnnoncesCards";
import LinksComponent from "SanityComponents/LocationAnnoncesLp/LinksComponent";
import formatUrl from "utils/FormatUrl";
import Card from "SanityComponents/GuideDuCredit/GuideCards";
import Cards from "SanityComponents/LandingPage/Cards";
import BesoinAideCard from "SanityComponents/CalculezVotreBudgetComponents/BesoinAideComponent/BesoinAideCard/BesoinAideCard";
import Feedback from "SanityComponents/OffersPro/FeedBack/Feadback";
import GuideButtons from "SanityComponents/GuideDuCredit/GuideButtons";
import EstimationImmobilier from "SanityComponents/EstimationImmobilier";
import EstimationHeaderNew from "SanityComponents/CreditImmobilierComponents/EstimationHeaderNew";
import ImageTitleSubTitleBtnFlex from "SanityComponents/ImageTitleSubTitleBtnFlex";
import WhatssapComponent from "SanityComponents/WhatssapComponent";
import MostRecentArticles from "SanityComponents/MostRecentArticles";

const client = createClient({
  apiVersion: "2023-01-01",
  dataset: "production" || "production",
  projectId: "n2i0cmq4" || "",
  useCdn: false,
});
function urlFor(source) {
  return createImageUrlBuilder(client).image(source);
}

export function DisplayPage(props: {
  data: any | null;
  slug?: string;
  achat_articles?: any;
  louer_articles?: any | null;
}) {
  const { t, lang } = useTranslation("common");

  const { data, slug } = props;

  return (
    <div style={{ paddingTop: "60px" }}>
      {data?.content.map((item, key) => {
        if (item._type == "lpheader") {
          return (
            <>
              {item.makePicOnBackground ? (
                item.background_image ? (
                  <>
                    <EstimationHeaderNew
                      title={item.titre ? item.titre[lang] : ""}
                      subtitle={item.soustitre ? item.soustitre[lang] : null}
                      overlay={item.overlay_image ? item.overlay_image : null}
                      content={item.content ? item.content : null}
                      buttonText={item.button ? item.button[lang] : null}
                      button_link={item.button_link ? item.button_link : null}
                      backgroundUrl={
                        item.background_image
                          ? urlFor(item.background_image)
                              .format("webp")
                              .auto("format")
                              .fit("clip")
                              .auto("format")
                              .toString()
                          : null
                      }
                      annoncesSearchBar={
                        item.SearchBarAnnonces ? item.SearchBarAnnonces : null
                      }
                      secondeSubtitle={
                        item.secondsoustitre ? item.secondsoustitre[lang] : ""
                      }
                      t={t}
                      lang={lang}
                    />
                  </>
                ) : null
              ) : item.background_image ? (
                <>
                  <EstimationHeader
                    index={key}
                    title={item.titre ? item.titre[lang] : ""}
                    subtitle={item.soustitre ? item.soustitre[lang] : null}
                    secondeSubtitle={
                      item.secondsoustitre ? item.secondsoustitre[lang] : null
                    }
                    buttonText={item.button ? item.button[lang] : ""}
                    button_link={item.button_link ? item.button_link : ""}
                    overlay={item.overlay_image ? item.overlay_image : null}
                    content={item.content ? item.content : null}
                    backgroundUrl={
                      item.background_image
                        ? urlFor(item.background_image)
                            .format("webp")
                            .auto("format")
                            .fit("clip")
                            .auto("format")
                            .toString()
                        : null
                    }
                    annoncesSearchBar={
                      item.SearchBarAnnonces ? item.SearchBarAnnonces : null
                    }
                    searchBar={item.SearchBar ? item.SearchBar : null}
                    SearchBarInputButton={
                      item.SearchBarInputButton
                        ? item.SearchBarInputButton
                        : null
                    }
                    t={t}
                    lang={lang}
                  />
                </>
              ) : null}
            </>
          );
        } else if (item._type == "SubHeaderWithLinks") {
          return (
            <SubHeader
              key={key}
              title={item.titre ? item.titre[lang] : ""}
              subTitle={item.subTitle ? item.subTitle[lang] : ""}
              link_text1={item.link_text1 ? item.link_text1[lang] : null}
              link1={item.link1 ? item.link1 : null}
              outext={item.outext ? item.outext[lang] : null}
              link_text2={item.link_text2 ? item.link_text2[lang] : null}
              link2={item.link2 ? item.link2 : null}
              rest_subTitle={item.rest_subTitle ? item.rest_subTitle[lang] : ""}
              t={t}
            />
          );
        } else if (item._type == "WhatssapComponent") {
          return (
            <WhatssapComponent
              number={item?.numberPhone ? item.numberPhone : null}
              message={item?.message ? item.message[lang] : null}
            />
          );
        } else if (item._type == "MostRecentArticles") {
          return (
            <MostRecentArticles
              key={key}
              title={item.titre[lang]}
              linkArticles={
                props.achat_articles
                  ? props.achat_articles.slice(0, 10)
                  : props.louer_articles
                  ? props.louer_articles.slice(0, 10)
                  : null
              }
              lang={lang}
            />
          );
        } else if (item._type == "SubHeader") {
          return (
            <SubHeader
              key={key}
              title={item.titre ? item.titre[lang] : ""}
              subTitle={item.subTitle ? item.subTitle[lang] : ""}
            />
          );
        } else if (item._type == "TextBanner") {
          return (
            <TextBanner
              title={item.titre ? item.titre[lang] : ""}
              subtitle={item.soustitre ? item.soustitre[lang] : null}
              overlay={item.overlay_image ? item.overlay_image : null}
              backgroundColor={
                item.background_color ? item.background_color : null
              }
              backgroundUrl={
                item.background_image
                  ? urlFor(item.background_image)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()
                  : null
              }
            />
          );
        } else if (item._type == "OffreProComponent") {
          return (
            <OffreProComponent
              title={item.titre ? item.titre[lang] : ""}
              texte={item.text ? item.text[lang] : ""}
              text2={item.text2 ? item.text2[lang] : ""}
              overlay={item.overlay_image ? item.overlay_image : null}
              button_text={item.button_text ? item.button_text[lang] : ""}
              backgroundColor={
                item.background_color ? item.background_color : null
              }
              orientation_lr={item.orientation_lr ? item.orientation_lr : null}
              button_link={item.button_link ? item.button_link : null}
              mainImage={
                item.mainImage
                  ? urlFor(item.mainImage)
                      .width(600)
                      .height(600)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()
                  : null
              }
            />
          );
        } else if (item._type == "SanityHeadSeo") {
          return (
            <SanityHeadSeo
              key={key}
              title={item.titre ? item.titre[lang] : ""}
              ogTitle={item.titre ? item.titre[lang] : ""}
              description={item.description ? item.description[lang] : ""}
              ogDescription={item.description ? item.description[lang] : ""}
              canonicalUrl={item.canonicalUrl ? item.canonicalUrl : ""}
              ogTwitterImage={
                item.mainImage
                  ? urlFor(item.mainImage)
                      .width(250)
                      .height(250)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()
                  : null
              }
              ogType={item.ogType ? item.ogType : null}
              ogImageUrl={
                item.mainImage
                  ? urlFor(item.mainImage)
                      .width(250)
                      .height(250)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()
                  : null
              }
              structuredData={null}
            >
              <></>
            </SanityHeadSeo>
          );
        } else if (item._type == "PackContainerComponent") {
          return <PackContainerComponent title={item.titre} />;
        } else if (item._type == "HeaderEstimation") {
          if (item.background_image) {
            return (
              <EstimationHeader
                title={item.titre ? item.titre[lang] : ""}
                overlay={item.overlay_image ? item.overlay_image : null}
                content={item.content ? item.content : null}
                backgroundUrl={
                  item.background_image
                    ? urlFor(item.background_image)
                        .format("webp")
                        .auto("format")
                        .fit("clip")
                        .auto("format")
                        .toString()
                    : null
                }
                annoncesSearchBar={
                  item.SearchBarAnnonces ? item.SearchBarAnnonces : null
                }
                t={null}
                lang={"fr"}
              />
            );
          }
        } else if (item.AnnoncesCards?.AnnoncesCards?.length > 0) {
          return (
            <>
              <div className={style.annoncescardContainer}>
                {item.AnnoncesCards?.titre ? (
                  <div className={style.cardTitle}>
                    {item.AnnoncesCards?.titre ? (
                      <p className={style.title}>
                        {item.AnnoncesCards?.titre[lang]}
                        {/* Comment pouvons-nous{" "}
                                <span style={{ fontWeight: "500" }}>vous aider</span> ? */}
                      </p>
                    ) : null}
                  </div>
                ) : null}

                <div className={style.annoncescards}>
                  {item.AnnoncesCards?.AnnoncesCards?.map((elem, index) => {
                    return (
                      <>
                        {elem && (
                          <>
                            <AnnoncesCards
                              content={elem.subtitle ? elem.subtitle[lang] : ""}
                              overlay={
                                elem.overlay_image ? elem.overlay_image : null
                              }
                              // content={elem.text[lang]}
                              backgroundUrl={
                                elem.mainImage
                                  ? urlFor(elem.mainImage)
                                      .format("webp")
                                      .auto("format")
                                      .fit("clip")
                                      .auto("format")
                                      .toString()
                                  : null
                              }
                            />
                          </>
                        )}
                      </>
                    );
                  })}
                </div>
              </div>
            </>
          );
        } else if (
          item?.annoncesLpLinksObject?.AnnoncesLpLinksArray?.length > 0
        ) {
          return (
            <>
              <div className={style.linksContainerG}>
                <LinksComponent
                  data={
                    item.annoncesLpLinksObject?.AnnoncesLpLinksArray
                      ? item.annoncesLpLinksObject.AnnoncesLpLinksArray
                      : null
                  }
                  lang={lang}
                  isFlex={
                    item.annoncesLpLinksObject?.isFlex
                      ? item.annoncesLpLinksObject.isFlex
                      : null
                  }
                />
              </div>
            </>
          );
        } else if (item?.AnnoncesLpLinksArray?.length > 0) {
          return (
            <>
              <div className={style.linksContainerG}>
                <LinksComponent
                  data={
                    item.AnnoncesLpLinksArray ? item.AnnoncesLpLinksArray : null
                  }
                  lang={lang}
                />
              </div>
            </>
          );
        } else if (item.GuidCreditPageCards) {
          return (
            <>
              {item.GuidCreditPageCards?.GuidCreditPageCards?.length > 0 && (
                <div
                  className={style.guideCardContainer}
                  style={{ top: "0px" }}
                >
                  <div className={style.guideCardTitle}>
                    {item.GuidCreditPageCards?.titre && (
                      <p className={style.guidetitle}>
                        {item.GuidCreditPageCards?.titre[lang]}
                      </p>
                    )}

                    {item.GuidCreditPageCards?.button && (
                      <p className={style.guidebtn}>
                        <a
                          rel={
                            item.GuidCreditPageCards?.buttonLink.includes(
                              "list"
                            ) ||
                            item.GuidCreditPageCards?.buttonLink.includes(
                              "map"
                            ) ||
                            item.GuidCreditPageCards?.buttonLink.includes(
                              "?"
                            ) ||
                            item.GuidCreditPageCards?.buttonLink.includes(
                              "conditions"
                            ) ||
                            item.GuidCreditPageCards?.buttonLink.includes(
                              "contact"
                            )
                              ? "nofollow noopener noreferrer noindex"
                              : "follow"
                          }
                          href={formatUrl(
                            item.GuidCreditPageCards?.buttonLink
                              ? item.GuidCreditPageCards?.buttonLink
                              : "",
                            lang
                          )}
                        >
                          {item.GuidCreditPageCards?.button[lang]}
                        </a>
                      </p>
                    )}
                  </div>

                  <div className={style.postsCardsContent}>
                    {item.GuidCreditPageCards?.GuidCreditPageCards?.map(
                      (elem, index) => {
                        return (
                          <>
                            {elem && (
                              <a
                                rel={
                                  elem?.slug?.current.includes("list") ||
                                  elem?.slug?.current.includes("map") ||
                                  elem?.slug?.current.includes("?") ||
                                  elem?.slug?.current.includes("conditions") ||
                                  elem?.slug?.current.includes("contact")
                                    ? "nofollow noopener noreferrer noindex"
                                    : "follow"
                                }
                                href={formatUrl(
                                  `/guide-du-credit/${elem?.slug?.current}`,
                                  lang
                                )}
                              >
                                <Card
                                  image={
                                    elem.mainImage &&
                                    urlFor(elem.mainImage)
                                      .width(404)
                                      .height(187)
                                      .format("webp")
                                      .auto("format")
                                      .fit("clip")
                                      .auto("format")
                                      .toString()
                                  }
                                  title={elem.title ? elem.title[lang] : ""}
                                  subtitle={
                                    elem.subtitle ? elem.subtitle[lang] : ""
                                  }
                                  width={elem.width ? elem.width : 404}
                                  height={elem.height ? elem.height : 187}
                                  date={elem._createdAt}
                                  lang={lang}
                                />
                              </a>
                            )}
                          </>
                        );
                      }
                    )}
                  </div>
                </div>
              )}
            </>
          );
        } else if (item.GuidAcheteurCards) {
          return (
            <>
              {item.GuidAcheteurCards?.GuidAcheteurCardsArray?.length > 0 && (
                <div
                  className={style.guideCardContainer}
                  style={{ top: "0px" }}
                >
                  <div className={style.guideCardTitle}>
                    {item.GuidAcheteurCards?.titre && (
                      <p className={style.guidetitle}>
                        {item.GuidAcheteurCards?.titre[lang]}
                      </p>
                    )}

                    {item.GuidAcheteurCards?.button && (
                      <p className={style.guidebtn}>
                        <a
                          rel={
                            item.GuidAcheteurCards?.buttonLink?.includes(
                              "list"
                            ) ||
                            item.GuidAcheteurCards?.buttonLink?.includes(
                              "map"
                            ) ||
                            item.GuidAcheteurCards?.buttonLink?.includes("?") ||
                            item.GuidAcheteurCards?.buttonLink?.includes(
                              "conditions"
                            ) ||
                            item.GuidAcheteurCards?.buttonLink?.includes(
                              "contact"
                            )
                              ? "nofollow noopener noreferrer noindex"
                              : "follow"
                          }
                          href={formatUrl(
                            item.GuidAcheteurCards?.buttonLink
                              ? item.GuidAcheteurCards?.buttonLink
                              : "",
                            lang
                          )}
                        >
                          {item.GuidAcheteurCards?.button[lang]}
                        </a>
                      </p>
                    )}
                  </div>

                  <div className={style.postsCardsContent}>
                    {item.GuidAcheteurCards?.GuidAcheteurCardsArray?.map(
                      (elem, index) => {
                        return (
                          <>
                            {elem && (
                              <a
                                className={style.postCardLink}
                                rel={
                                  elem?.slug?.current?.includes("list") ||
                                  elem?.slug?.current?.includes("map") ||
                                  elem?.slug?.current?.includes("?") ||
                                  elem?.slug?.current?.includes("conditions") ||
                                  elem?.slug?.current?.includes("contact")
                                    ? "nofollow noopener noreferrer noindex"
                                    : "follow"
                                }
                                href={formatUrl(
                                  `/acheter/guide/${elem?.slug?.current}`,
                                  lang
                                )}
                              >
                                <Card
                                  image={
                                    elem?.mainImage
                                      ? urlFor(elem?.mainImage)
                                          .width(404)
                                          .height(187)
                                          .format("webp")
                                          .auto("format")
                                          .fit("clip")
                                          .auto("format")
                                          .toString()
                                      : null
                                  }
                                  title={elem?.title ? elem?.title[lang] : ""}
                                  subtitle={
                                    elem?.subtitle ? elem?.subtitle[lang] : ""
                                  }
                                  width={elem?.width ? elem?.width : 404}
                                  height={elem?.height ? elem?.height : 187}
                                  date={elem._createdAt}
                                  lang={lang}
                                />
                              </a>
                            )}
                          </>
                        );
                      }
                    )}
                  </div>
                </div>
              )}
            </>
          );
        } else if (item.GuidLocationCards) {
          return (
            <>
              {item.GuidLocationCards?.GuidLocationCardsArray?.length > 0 && (
                <div className={style.guideCardContainer}>
                  <div className={style.guideCardTitle}>
                    {item.GuidLocationCards?.titre && (
                      <p className={style.guidetitle}>
                        {item.GuidLocationCards?.titre[lang]}
                      </p>
                    )}

                    {item.GuidLocationCards?.button && (
                      <p className={style.guidebtn}>
                        <a
                          rel={
                            item.GuidLocationCards?.buttonLink?.includes(
                              "list"
                            ) ||
                            item.GuidLocationCards?.buttonLink?.includes(
                              "map"
                            ) ||
                            item.GuidLocationCards?.buttonLink?.includes("?") ||
                            item.GuidLocationCards?.buttonLink?.includes(
                              "conditions"
                            ) ||
                            item.GuidLocationCards?.buttonLink?.includes(
                              "contact"
                            )
                              ? "nofollow noopener noreferrer noindex"
                              : "follow"
                          }
                          href={formatUrl(
                            item.GuidLocationCards?.buttonLink
                              ? item.GuidLocationCards?.buttonLink
                              : null,
                            lang
                          )}
                        >
                          {item.GuidLocationCards?.button[lang]}
                        </a>
                      </p>
                    )}
                  </div>

                  <div className={style.postsCardsContent}>
                    {item.GuidLocationCards?.GuidLocationCardsArray?.map(
                      (elem, index) => {
                        return (
                          <>
                            {elem && (
                              <a
                                className={style.postCardLink}
                                rel={
                                  elem?.slug?.current?.includes("list") ||
                                  elem?.slug?.current?.includes("map") ||
                                  elem?.slug?.current?.includes("?") ||
                                  elem?.slug?.current?.includes("conditions") ||
                                  elem?.slug?.current?.includes("contact")
                                    ? "nofollow noopener noreferrer noindex"
                                    : "follow"
                                }
                                href={formatUrl(
                                  `/louer/guide-location/${elem?.slug?.current}`,
                                  lang
                                )}
                              >
                                <Card
                                  image={
                                    elem.mainImage
                                      ? urlFor(elem.mainImage)
                                          .width(404)
                                          .height(187)
                                          .format("webp")
                                          .auto("format")
                                          .fit("clip")
                                          .auto("format")
                                          .toString()
                                      : null
                                  }
                                  title={elem.title ? elem.title[lang] : ""}
                                  subtitle={
                                    elem.subtitle ? elem.subtitle[lang] : ""
                                  }
                                  width={elem.width ? elem.width : 404}
                                  height={elem.height ? elem.height : 187}
                                  date={elem._createdAt}
                                  lang={lang}
                                />
                              </a>
                            )}
                          </>
                        );
                      }
                    )}
                  </div>
                </div>
              )}
            </>
          );
        } else if (item.GuidPrixCards) {
          return (
            <>
              {item.GuidPrixCards?.GuidPrixCardsArray?.length > 0 && (
                <div
                  className={style.guideCardContainer}
                  style={{ top: "0px" }}
                >
                  <div className={style.guideCardTitle}>
                    {item.GuidPrixCards?.titre && (
                      <p className={style.guidetitle}>
                        {item.GuidPrixCards?.titre[lang]}
                      </p>
                    )}

                    {item.GuidPrixCards?.button && (
                      <p className={style.guidebtn}>
                        <a
                          rel={
                            item.GuidPrixCards?.buttonLink?.includes("list") ||
                            item.GuidPrixCards?.buttonLink?.includes("map") ||
                            item.GuidPrixCards?.buttonLink?.includes("?") ||
                            item.GuidPrixCards?.buttonLink?.includes(
                              "conditions"
                            ) ||
                            item.GuidPrixCards?.buttonLink?.includes("contact")
                              ? "nofollow noopener noreferrer noindex"
                              : "follow"
                          }
                          href={formatUrl(
                            item.GuidPrixCards?.buttonLink
                              ? item.GuidPrixCards?.buttonLink
                              : "",
                            lang
                          )}
                        >
                          {item.GuidPrixCards?.button[lang]}
                        </a>
                      </p>
                    )}
                  </div>

                  <div className={style.postsCardsContent}>
                    {item.GuidPrixCards?.GuidPrixCardsArray?.map(
                      (elem, index) => {
                        return (
                          <>
                            {elem && (
                              <a
                                className={style.postCardLink}
                                rel={
                                  elem?.slug?.current?.includes("list") ||
                                  elem?.slug?.current?.includes("map") ||
                                  elem?.slug?.current?.includes("?") ||
                                  elem?.slug?.current?.includes("conditions") ||
                                  elem?.slug?.current?.includes("contact")
                                    ? "nofollow noopener noreferrer noindex"
                                    : "follow"
                                }
                                href={formatUrl(
                                  `/guide-du-prix/${elem?.slug?.current}`,
                                  lang
                                )}
                              >
                                <Card
                                  image={
                                    elem.mainImage &&
                                    urlFor(elem.mainImage)
                                      .width(404)
                                      .height(187)
                                      .format("webp")
                                      .auto("format")
                                      .fit("clip")
                                      .auto("format")
                                      .toString()
                                  }
                                  title={elem.title ? elem.title[lang] : ""}
                                  subtitle={
                                    elem.subtitle ? elem.subtitle[lang] : ""
                                  }
                                  width={elem.width ? elem.width : 404}
                                  height={elem.height ? elem.height : 187}
                                  date={elem._createdAt}
                                  lang={lang}
                                />
                              </a>
                            )}
                          </>
                        );
                      }
                    )}
                  </div>
                </div>
              )}
            </>
          );
        } else if (item.card) {
          return (
            <>
              {item.card?.AideCards?.length > 0 && (
                <div
                  className={style.cardContainer}
                  style={{ paddingTop: "0px" }}
                >
                  {item.card?.titre ? (
                    <div className={style.cardTitle}>
                      <p>
                        {item.card?.titre ? item.card?.titre[lang] : null}
                        {/* Comment pouvons-nous{" "}
                      <span style={{ fontWeight: "500" }}>vous aider</span> ? */}
                      </p>
                    </div>
                  ) : null}

                  <div className={style.cards}>
                    {item.card?.AideCards?.map((elem, index) => {
                      return (
                        <>
                          {elem && (
                            <>
                              <AideCards
                                title={elem.titre ? elem.titre[lang] : null}
                                subtitle={
                                  elem.soustitre ? elem.soustitre[lang] : ""
                                }
                                overlay={
                                  elem.overlay_image ? elem.overlay_image : null
                                }
                                content={elem.text ? elem.text[lang] : ""}
                                backgroundUrl={
                                  elem.mainImage &&
                                  urlFor(elem.mainImage)
                                    .format("webp")
                                    .auto("format")
                                    .fit("clip")
                                    .auto("format")
                                    .toString()
                                }
                                width={elem.width ? elem.width : 90}
                                height={elem.height ? elem.height : 90}
                              />
                              {/* <AnnoncesCards
                                title={elem.titre ? elem.titre[lang] : ""}
                                overlay={elem.overlay_image}
                                content={elem.text[lang]}
                                backgroundUrl={urlFor(elem.mainImage)
                                  .format("webp")
                                  .auto("format")
                                  .fit("clip")
                                  .auto("format")
                                  .toString()}
                              /> */}
                            </>
                          )}
                        </>
                      );
                    })}
                  </div>
                </div>
              )}
            </>
          );
        } else if (item._type == "QuestionImmobilier") {
          return (
            <div>
              <Question
                title={item.titre ? item.titre[lang] : ""}
                text={item.text ? item.text[lang] : ""}
                buttonText={item.button_text ? item.button_text[lang] : ""}
                image={
                  item.mainImage &&
                  urlFor(item.mainImage)
                    .format("webp")
                    .auto("format")
                    .fit("clip")
                    .auto("format")
                    .toString()
                }
                button_link={item.button_link ? item.button_link : ""}
              />
            </div>
          );
        } else if (item._type == "SimulezCredit") {
          return (
            <div className={style.simulez}>
              <Simulez
                title={item.titre ? item.titre[lang] : ""}
                buttonText={item.button_text ? item.button_text[lang] : ""}
                button_link={item.button_link ? item.button_link : ""}
              />
            </div>
          );
        } else if (item._type == "Faq") {
          return <FAQ data={item} lang={lang} />;
        } else if (item._type == "SanityFooter") {
          return (
            <div className={style.footer}>
              <div className={style.footerDesk}>
                <Footer
                  propos={item.propos ? item.propos[lang] : null}
                  proposText={item.text ? item.text[lang] : ""}
                  donnee={item.donnees ? item.donnees[lang] : null}
                  donneeText={item.textdonnee ? item.textdonnee[lang] : null}
                  technologie={item.technologie ? item.technologie[lang] : null}
                  technologieText={
                    item.texttechnologies ? item.texttechnologies[lang] : null
                  }
                  logo={
                    item.agenz_logo &&
                    urlFor(item.agenz_logo)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()
                  }
                  facebook={
                    item.facebook_logo &&
                    urlFor(item.facebook_logo)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()
                  }
                  instagram_logo={
                    item.instagram_logo &&
                    urlFor(item.instagram_logo)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()
                  }
                  linked_in={
                    item.linkedin_logo &&
                    urlFor(item.linkedin_logo)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()
                  }
                  socialMediaText={
                    item.socialMediatext ? item.socialMediatext : null
                  }
                  copyRightText={
                    item.permission_text ? item.permission_text : null
                  }
                />
              </div>
              {/* <div className={style.footerMobile}>
                    <MobileFooter/>
                </div> */}
            </div>
          );
        } else if (item._type == "GuideThreeButtons") {
          return (
            <>
              <ThreeGuideButtons
                button1={item.button1 ? item.button1[lang] : ""}
                link_button1={item.link_button1 ? item.link_button1 : ""}
                button2={item.button2 ? item.button2[lang] : ""}
                link_button2={item.link_button2 ? item.link_button2 : ""}
                button3={item.button3 ? item.button3[lang] : ""}
                link_button3={item.link_button3 ? item.link_button3 : ""}
                slug={slug}
                lang={lang}
              />
            </>
          );
        } else if (item._type == "GuideButtons") {
          return (
            <>
              <GuideButtons
                btnsDetails={item.buttonsGuide ? item.buttonsGuide : null}
                lang={lang}
              />
            </>
          );
        } else if (item._type == "Faq") {
          return (
            <>
              <FAQ data={item ? item : null} lang={lang} />;
            </>
          );
        } else if (item._type == "ThreeButtons") {
          return (
            <>
              <ThreeButtons
                btn1={item.titre_button1 ? item.titre_button1[lang] : ""}
                // link1 = {elem.button_link1[lang]}

                btn2={item.titre_button2 ? item.titre_button2[lang] : null}
                // link2 = {elem.button_link2[lang]}

                btn3={item.titre_button3 ? item.titre_button3[lang] : null}
                // link3 = {elem.button_link3[lang]}
                provinces={ProvincesMaroc}
                t={t}
              />
            </>
          );
        } else if (item._type == "ImageTitleSubTitleBtnFlex") {
          return (
            <ImageTitleSubTitleBtnFlex
              title={item.title ? item.title[lang] : ""}
              subtitle={item.subtitle ? item.subtitle[lang] : ""}
              buttonText={item.titre_button ? item.titre_button[lang] : ""}
              button_link={item.button_link ? item.button_link : ""}
              image={
                item.mainImage
                  ? urlFor(item.mainImage)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()
                  : null
              }
              lang={lang}
            />
          );
        } else if (item._type == "TitleThreeButtons") {
          return (
            <EstimationImmobilierThreeButtons
              titre={item.titre ? item.titre[lang] : ""}
              btn1={item.titre_button1 ? item.titre_button1[lang] : ""}
              link1={item.button_link1 ? item.button_link1 : ""}
              btn2={item.titre_button2 ? item.titre_button2[lang] : null}
              link2={item.button_link2 ? item.button_link2 : ""}
              btn3={item.titre_button3 ? item.titre_button3[lang] : null}
              link3={item.button_link3 ? item.button_link3 : ""}
            />
          );
        } else if (item._type == "TitleTwoTextes") {
          return (
            <EstimationImmobilierTitleTwoTextes
              title={item.titre ? item.titre[lang] : null}
              texte1={item.text ? item.text[lang] : null}
              texte2={item.text2 ? item.text2[lang] : null}
            />
          );
        } else if (item._type == "AddExampleListings") {
          return <>{item.title ? item.title[lang] : null}</>;
        } else if (item._type == "TitleOneTextes") {
          return (
            <EstimationImmobilierTitleOneTexte
              title={item.titre ? item.titre[lang] : null}
              texte1={item.text ? item.text[lang] : null}
            />
          );
        } else if (item._type == "SanityHeadSeo") {
          return (
            <SanityHeadSeo
              key={key}
              title={item.titre ? item.titre[lang] : ""}
              ogTitle={item.titre ? item.titre[lang] : ""}
              description={item.description ? item.description[lang] : ""}
              ogDescription={item.description ? item.description[lang] : ""}
              canonicalUrl={item.canonicalUrl ? item.canonicalUrl : null}
              ogTwitterImage={
                item.mainImage
                  ? urlFor(item.mainImage)
                      .width(250)
                      .height(250)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()
                  : null
              }
              ogType={item.ogType ? item.ogType : null}
              ogImageUrl={
                item.mainImage
                  ? urlFor(item.mainImage)
                      .width(250)
                      .height(250)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()
                  : null
              }
              structuredData={null}
            >
              <></>
            </SanityHeadSeo>
          );
        } else if (item._type == "EstimationImmobilier") {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <EstimationImmobilier
                title={item.titre ? item.titre[lang] : ""}
                text={item.text ? item.text[lang] : ""}
                buttonText={item.button_text ? item.button_text[lang] : null}
                image={
                  item.mainImage &&
                  urlFor(item.mainImage)
                    .format("webp")
                    .auto("format")
                    .fit("clip")
                    .auto("format")
                    .toString()
                }
                button_link={item.button_link ? item.button_link : ""}
                color="white"
                text_color={item.text_color ? item.text_color[lang] : null}
              />
            </div>
          );
        } else if (item._type == "EstimationImmobilierComponent") {
          return (
            <div>
              <Question
                title={item.titre ? item.titre[lang] : ""}
                text={item.text ? item.text[lang] : null}
                buttonText={item.button_text ? item.button_text[lang] : null}
                image={
                  item.mainImage &&
                  urlFor(item.mainImage)
                    .format("webp")
                    .auto("format")
                    .fit("clip")
                    .auto("format")
                    .toString()
                }
                button_link={item.button_link ? item.button_link : ""}
                color="black"
                blockquote={true}
              />
            </div>
          );
        } else if (item._type == "LpPrixImmobilier") {
          return (
            <div className={style.simulez}>
              <LpPrixImmobilier
                title={item.titre ? item.titre[lang] : null}
                texte={item.texte ? item.texte[lang] : null}
                buttonText={item.button_text ? item.button_text[lang] : null}
                button_link={item.button_link ? item.button_link : ""}
              />
            </div>
          );
        } else if (item.CalculCard?.length > 0) {
          return (
            <div className={style.BesoinCardsContainer}>
              {item.CalculCard.map((element, ind) => {
                return (
                  <>
                    <BesoinAideCard
                      title={element.titre ? element.titre[lang] : ""}
                      description={
                        element.description ? element.description[lang] : ""
                      }
                    />
                  </>
                );
              })}
            </div>
          );
        } else if (item.LandingPageCards) {
          return (
            <div key={key}>
              {item.LandingPageCards && item.LandingPageCards.length > 0 ? (
                <>
                  <div className={style.LpcardsPadding}>
                    {item.LandingPageCards.map((elem, index) => {
                      return (
                        <div key={index}>
                          {elem && (
                            <Cards
                              titre={elem.titre ? elem.titre[lang] : ""}
                              texte={elem.text ? elem.text[lang] : ""}
                              button_text={
                                elem.button_text ? elem.button_text[lang] : ""
                              }
                              lien1={elem.lien1 ? elem.lien1[lang] : null}
                              href1={elem.href1 ? elem.href1 : ""}
                              lien2={elem.lien2 ? elem.lien2[lang] : null}
                              href2={elem.href2 ? elem.href2 : ""}
                              button_link={
                                elem.button_link ? elem.button_link : ""
                              }
                              image={
                                elem.mainImage
                                  ? urlFor(elem.mainImage)
                                      .format("webp")
                                      .auto("format")
                                      .fit("clip")
                                      .auto("format")
                                      .toString()
                                  : null
                              }
                              t={t}
                            />
                          )}
                        </div>
                      );
                    })}
                  </div>
                </>
              ) : null}
            </div>
          );
        } else if (item._type == "FeadBack") {
          return (
            <div className={style.feedback}>
              <Feedback
                feadback={item.FeadBack ? item.FeadBack : ""}
                lang={lang}
              />
            </div>
          );
        } else {
          return (
            <>
              {item.CommentResussirComponent?.length > 0 &&
                item.CommentResussirComponent.map((element, ind) => {
                  return (
                    <>
                      <CommentReusirVotreVenteCards
                        title={element.titre && element.titre[lang]}
                        button_text={
                          element.button_text && element.button_text[lang]
                        }
                        body={
                          lang == "ar"
                            ? element?.body_text?.body_ar
                              ? element?.body_text?.body_ar
                              : null
                            : element?.body_text?.body_fr
                            ? element?.body_text?.body_fr
                            : null
                        }
                        button_link={
                          element.button_link ? element.button_link : ""
                        }
                        mainImage={
                          element.mainImage
                            ? urlFor(element.mainImage)
                                .format("webp")
                                .auto("format")
                                .fit("clip")
                                .auto("format")
                                .toString()
                            : null
                        }
                        orientation={
                          element.orientation_lr ? element.orientation_lr : ""
                        }
                        lang={lang}
                      />
                    </>
                  );
                })}
              {item.OffreProComponent?.length > 0 &&
                item.OffreProComponent.map((element, ind) => {
                  return (
                    <OffreProComponent
                      title={element.titre ? element.titre[lang] : ""}
                      texte={element.text ? element.text[lang] : ""}
                      text2={element.text2 ? element.text2[lang] : ""}
                      overlay={
                        element.overlay_image ? element.overlay_image : ""
                      }
                      button_text={
                        element.button_text ? element.button_text[lang] : ""
                      }
                      backgroundColor={
                        element.background_color ? element.background_color : ""
                      }
                      orientation_lr={
                        element.orientation_lr ? element.orientation_lr : ""
                      }
                      button_link={
                        element.button_link ? element.button_link : ""
                      }
                      mainImage={
                        element.mainImage
                          ? urlFor(element.mainImage)
                              .width(600)
                              .height(600)
                              .format("webp")
                              .auto("format")
                              .fit("clip")
                              .auto("format")
                              .toString()
                          : null
                      }
                      lang={lang}
                    />
                  );
                })}
            </>
          );
        }
      })}
    </div>
  );
}
